import axios from "axios";
import { ElMessage } from 'element-plus'

// 查询退款记录
export async function getRefundListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/order/refunds/query?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}

// 查询手动退款列表
export async function getManualRefundListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/order/refunds/manual/query?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}

// 退款审核
export async function auditingFun(params) {
    return new Promise((resolve, reject) => {
        axios.post('/api/bms/order/refunds/request/refund', params).then((res) => {
            if (res.data.code == 200) {
                ElMessage.success(res.data.msg);
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}